import React, { useState } from 'react';

function AddInExistingIcon() {
    const [isHovered, setIsHovered] = useState(false);

    let fillColor = "#6c6c6c"
    let hoverColor = "#000"

    const handleMouseEnter = () => {
        setIsHovered(true);
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" style={{ "width": "1.8rem", height: "1.8rem" }} fill={isHovered ? hoverColor : fillColor} onMouseLeave={handleMouseLeave} onMouseEnter={handleMouseEnter}>
            <defs>
                <clipPath id="clip-Add_in_Existing">
                    <rect width="50" height="50" />
                </clipPath>
            </defs>
            <g id="Add_in_Existing" data-name="Add in Existing" clipPath="url(#clip-Add_in_Existing)">
                <g id="noun-add-to-existing-1517211" transform="translate(-119 -47.004)">
                    <path id="Subtraction_29" data-name="Subtraction 29" d="M13.83,27.661A1.426,1.426,0,0,1,12.4,26.238V15.256H1.423a1.425,1.425,0,0,1,0-2.85H12.4V1.425a1.425,1.425,0,1,1,2.85,0V12.407h10.98a1.425,1.425,0,1,1,0,2.85H15.255V26.238A1.426,1.426,0,0,1,13.83,27.661Z" transform="translate(130.649 58.651)" />
                    <path id="Rectangle_208" data-name="Rectangle 208" d="M4,1.5A2.5,2.5,0,0,0,1.5,4V44A2.5,2.5,0,0,0,4,46.5H44A2.5,2.5,0,0,0,46.5,44V4A2.5,2.5,0,0,0,44,1.5H4M4,0H44a4,4,0,0,1,4,4V44a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0Z" transform="translate(120 48.004)" />
                </g>
            </g>
        </svg>
    )
}

export default AddInExistingIcon;